import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

// Símbolos de moneda por código
const CURRENCY_SYMBOLS = {
  PEN: 'S/',
  USD: '$',
  EUR: '€',
  COP: '$',
  CLP: '$',
  MXN: '$',
  CRC: '₡'
};

// Variable para almacenar el símbolo de moneda de la empresa (se configura desde el contexto)
let empresaSymbol = null;

/**
 * Configura el símbolo de moneda de la empresa
 * Llamar desde EmpresaContext cuando se carga la empresa
 */
export const setEmpresaCurrencySymbol = (symbol) => {
  empresaSymbol = symbol;
};

/**
 * Obtiene el símbolo de moneda actual
 */
export const getCurrencySymbol = () => {
  return empresaSymbol || 'S/';
};

/**
 * Formatea una cantidad como moneda
 * Si no se especifica currency, usa el símbolo de la empresa
 */
export const formatCurrency = (value, currencyOrSymbol = null) => {
  let symbol;

  if (currencyOrSymbol) {
    // Si es un código de moneda (PEN, USD, etc), obtener el símbolo
    symbol = CURRENCY_SYMBOLS[currencyOrSymbol] || currencyOrSymbol;
  } else {
    // Usar el símbolo de la empresa
    symbol = getCurrencySymbol();
  }

  return `${symbol} ${parseFloat(value || 0).toLocaleString('es-PE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};

/**
 * Formatea moneda de forma compacta (para gráficos)
 */
export const formatCurrencyCompact = (value) => {
  const symbol = getCurrencySymbol();
  const num = parseFloat(value || 0);

  if (num >= 1000000) {
    return `${symbol} ${(num / 1000000).toFixed(1)}M`;
  }
  if (num >= 1000) {
    return `${symbol} ${(num / 1000).toFixed(1)}k`;
  }
  return `${symbol} ${num.toFixed(2)}`;
};

/**
 * Formatea un número con separadores de miles
 */
export const formatNumber = (value) => {
  return parseInt(value || 0).toLocaleString('es-PE');
};

/**
 * Formatea una fecha
 */
export const formatDate = (dateString, formatStr = 'dd MMM') => {
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, formatStr, { locale: es });
  } catch (error) {
    return dateString;
  }
};

/**
 * Obtiene el color según el cambio porcentual
 */
export const getChangeColor = (change) => {
  if (change > 0) return '#4CAF50'; // Verde
  if (change < 0) return '#F44336'; // Rojo
  return '#757575'; // Gris
};

/**
 * Obtiene el icono de tendencia según el cambio
 */
export const getTrendIcon = (change) => {
  if (change > 0) return '↑';
  if (change < 0) return '↓';
  return '→';
};

/**
 * Formatea el cambio porcentual
 */
export const formatPercentChange = (change) => {
  const absChange = Math.abs(change || 0);
  const icon = getTrendIcon(change);
  return `${icon} ${absChange.toFixed(1)}%`;
};
